import { render } from "./Loading.vue?vue&type=template&id=41f33044&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=41f33044&scoped=true&lang=css"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f33044"]])

export default __exports__